import React, { useState } from 'react';
import EditCard from './EditCard';
import * as styles from './PaymentCard.module.scss';
import Button from '../../components/Button';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { PlanInterval, PlanTier } from '../../graphql/generated/graphql';
import { BillingSummaryStatus } from '../../graphql/generated/graphql';
import SettingCard from '../../settings/SettingCard';

const BILLING_SUMMARY_FRAGMENT = gql(`
  fragment PaymentCard_billingSummary on BillingSummary {
    id
    status
    # eslint-disable-next-line @graphql-eslint/require-selections
    source {
      brand
      last4
      expMonth
      expYear
    }
  }
`);

interface PaymentCardProps {
  billingSummary: DocumentType<typeof BILLING_SUMMARY_FRAGMENT>;
  updateBilling: (values: {
    email?: string;
    source?: string;
    planTier?: PlanTier;
    planInterval?: PlanInterval;
  }) => Promise<unknown>;
}

const PaymentCard = ({ billingSummary, updateBilling }: PaymentCardProps) => {
  const { status, source } = billingSummary;
  const [isEditingCard, setIsEditingCard] = useState(false);

  if (isEditingCard) {
    return (
      <EditCard
        onClose={() => setIsEditingCard(false)}
        updateBilling={updateBilling}
      />
    );
  }

  let title = null;

  if (
    source &&
    [BillingSummaryStatus.Unpaid, BillingSummaryStatus.PastDue].includes(status)
  ) {
    title = (
      <>
        {source.brand} · {source.last4} ·{' '}
        <span className={styles.cardDeclined}>Declined</span>
      </>
    );
  } else if (source) {
    title = `${source.brand} · ${source.last4}`;
  }

  return (
    <SettingCard
      actions={
        <Button variant="secondary" onClick={() => setIsEditingCard(true)}>
          {source ? 'Edit' : 'Add'}
        </Button>
      }
      title={title ?? 'Add payment'}
      details={
        source
          ? `Expires ${source.expMonth.toString().padStart(2, '0')}/${
              source.expYear
            }`
          : 'No payment source on file'
      }
    />
  );
};

export default PaymentCard;
